import { render, staticRenderFns } from "./LogisticServicePriceModal.vue?vue&type=template&id=f296e1bc&scoped=true&"
import script from "./LogisticServicePriceModal.vue?vue&type=script&lang=js&"
export * from "./LogisticServicePriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f296e1bc",
  null
  
)

export default component.exports